import { IconSize, ICON_DIMENSION } from './constants';

export const getSizeStyle = (size: IconSize | number, isSquare: boolean) => {
  const iconSize = typeof size === 'number' ? size : ICON_DIMENSION[size];

  return isSquare
    ? {
        width: iconSize,
        height: iconSize
      }
    : {
        height: iconSize
      };
};
